export default "__VITE_ASSET__BpRKl4sv__"